module.exports = __webpack_public_path__ + "img/Master.24d58865.png";